
import { SET_ADDRESS } from '../actions/buildings-by-service-available';
const buildingsByServiceAvailable = (address = null, action) => {
  switch (action.type) {
    case SET_ADDRESS:
      return action.payload
    default:
      return address;
  }
};

export default buildingsByServiceAvailable;


// WEBPACK FOOTER //
// ./src/store/reducers/buildings-by-service-available.js